/**
 * membreFormConfig.js
 * 
 * 🔴 SOURCE UNIQUE - FICHIER DE CONFIGURATION CENTRALISÉ 🔴
 * 
 * Ce fichier contient TOUTES les configurations du formulaire "DEVENIR MEMBRE".
 * Toute modification ici se répercute automatiquement sur :
 * - RegisterPage.js (Formulaire public "DEVENIR MEMBRE")
 * - MembreCreationForm.js (Formulaire création par COOPER'S, Admin, Super Admin)
 * - Tout autre formulaire utilisant cette configuration
 * 
 * IMPORTANT: Ne dupliquez JAMAIS ces données dans d'autres fichiers !
 */

// ============================================================================
// INDICATIFS TÉLÉPHONIQUES AVEC DRAPEAUX
// ============================================================================
export const INDICATIFS_TELEPHONIQUES = [
  // France et DOM-TOM (9 chiffres)
  { code: '+33', flag: 'fr', name: 'France', digits: 9 },
  { code: '+590', flag: 'gp', name: 'Guadeloupe', digits: 9 },
  { code: '+594', flag: 'gf', name: 'Guyane française', digits: 9 },
  { code: '+596', flag: 'mq', name: 'Martinique', digits: 9 },
  { code: '+262', flag: 're', name: 'La Réunion', digits: 9 },
  { code: '+269', flag: 'km', name: 'Mayotte', digits: 7 },
  { code: '+687', flag: 'nc', name: 'Nouvelle-Calédonie', digits: 6 },
  { code: '+689', flag: 'pf', name: 'Polynésie française', digits: 6 },
  { code: '+508', flag: 'pm', name: 'Saint-Pierre-et-Miquelon', digits: 6 },
  { code: '+681', flag: 'wf', name: 'Wallis-et-Futuna', digits: 6 },
  { code: '+590', flag: 'bl', name: 'Saint-Barthélemy', digits: 9 },
  { code: '+590', flag: 'mf', name: 'Saint-Martin', digits: 9 },
  // Europe
  { code: '+32', flag: 'be', name: 'Belgique', digits: 9 },
  { code: '+41', flag: 'ch', name: 'Suisse', digits: 9 },
  { code: '+352', flag: 'lu', name: 'Luxembourg', digits: 9 },
  { code: '+377', flag: 'mc', name: 'Monaco', digits: 8 },
  { code: '+376', flag: 'ad', name: 'Andorre', digits: 6 },
  { code: '+49', flag: 'de', name: 'Allemagne', digits: 11 },
  { code: '+34', flag: 'es', name: 'Espagne', digits: 9 },
  { code: '+351', flag: 'pt', name: 'Portugal', digits: 9 },
  { code: '+39', flag: 'it', name: 'Italie', digits: 10 },
  { code: '+44', flag: 'gb', name: 'Royaume-Uni', digits: 10 },
  { code: '+31', flag: 'nl', name: 'Pays-Bas', digits: 9 },
  { code: '+43', flag: 'at', name: 'Autriche', digits: 10 },
  // Afrique francophone
  { code: '+212', flag: 'ma', name: 'Maroc', digits: 9 },
  { code: '+213', flag: 'dz', name: 'Algérie', digits: 9 },
  { code: '+216', flag: 'tn', name: 'Tunisie', digits: 8 },
  { code: '+221', flag: 'sn', name: 'Sénégal', digits: 9 },
  { code: '+225', flag: 'ci', name: "Côte d'Ivoire", digits: 10 },
  { code: '+226', flag: 'bf', name: 'Burkina Faso', digits: 8 },
  { code: '+227', flag: 'ne', name: 'Niger', digits: 8 },
  { code: '+228', flag: 'tg', name: 'Togo', digits: 8 },
  { code: '+229', flag: 'bj', name: 'Bénin', digits: 8 },
  { code: '+230', flag: 'mu', name: 'Maurice', digits: 8 },
  { code: '+223', flag: 'ml', name: 'Mali', digits: 8 },
  { code: '+224', flag: 'gn', name: 'Guinée', digits: 9 },
  { code: '+235', flag: 'td', name: 'Tchad', digits: 8 },
  { code: '+236', flag: 'cf', name: 'Centrafrique', digits: 8 },
  { code: '+237', flag: 'cm', name: 'Cameroun', digits: 9 },
  { code: '+241', flag: 'ga', name: 'Gabon', digits: 7 },
  { code: '+242', flag: 'cg', name: 'Congo', digits: 9 },
  { code: '+243', flag: 'cd', name: 'RD Congo', digits: 9 },
  { code: '+250', flag: 'rw', name: 'Rwanda', digits: 9 },
  { code: '+257', flag: 'bi', name: 'Burundi', digits: 8 },
  { code: '+261', flag: 'mg', name: 'Madagascar', digits: 9 },
  // Amérique
  { code: '+1', flag: 'ca', name: 'Canada', digits: 10 },
  { code: '+1', flag: 'us', name: 'États-Unis', digits: 10 },
  { code: '+509', flag: 'ht', name: 'Haïti', digits: 8 },
  // Asie
  { code: '+84', flag: 'vn', name: 'Vietnam', digits: 9 },
  { code: '+856', flag: 'la', name: 'Laos', digits: 8 },
  { code: '+855', flag: 'kh', name: 'Cambodge', digits: 9 },
  // Océan Indien
  { code: '+248', flag: 'sc', name: 'Seychelles', digits: 7 },
  { code: '+253', flag: 'dj', name: 'Djibouti', digits: 8 },
  { code: '+269', flag: 'km', name: 'Comores', digits: 7 },
];

// ============================================================================
// STATUTS JURIDIQUES
// ============================================================================
export const STATUTS_JURIDIQUES = [
  { value: 'SARL', label: 'SARL' },
  { value: 'SAS', label: 'SAS' },
  { value: 'SASU', label: 'SASU' },
  { value: 'EURL', label: 'EURL' },
  { value: 'SA', label: 'SA' },
  { value: 'SCI', label: 'SCI' },
  { value: 'EI', label: 'Entreprise Individuelle' },
  { value: 'MICRO', label: 'Micro-entreprise' },
  { value: 'ASSOCIATION', label: 'Association' },
  { value: 'COOPERATIVE', label: 'Coopérative' },
  { value: 'AUTRE', label: 'Autre' },
];

// ============================================================================
// LISTE DES PAYS AVEC DRAPEAUX
// ============================================================================
export const PAYS_LIST = [
  // France et DOM-TOM
  { code: 'FR', name: 'France', flag: 'fr' },
  { code: 'GP', name: 'Guadeloupe', flag: 'gp' },
  { code: 'MQ', name: 'Martinique', flag: 'mq' },
  { code: 'GF', name: 'Guyane française', flag: 'gf' },
  { code: 'RE', name: 'La Réunion', flag: 're' },
  { code: 'YT', name: 'Mayotte', flag: 'yt' },
  { code: 'NC', name: 'Nouvelle-Calédonie', flag: 'nc' },
  { code: 'PF', name: 'Polynésie française', flag: 'pf' },
  { code: 'PM', name: 'Saint-Pierre-et-Miquelon', flag: 'pm' },
  { code: 'WF', name: 'Wallis-et-Futuna', flag: 'wf' },
  { code: 'BL', name: 'Saint-Barthélemy', flag: 'bl' },
  { code: 'MF', name: 'Saint-Martin', flag: 'mf' },
  // Europe
  { code: 'BE', name: 'Belgique', flag: 'be' },
  { code: 'CH', name: 'Suisse', flag: 'ch' },
  { code: 'LU', name: 'Luxembourg', flag: 'lu' },
  { code: 'MC', name: 'Monaco', flag: 'mc' },
  { code: 'AD', name: 'Andorre', flag: 'ad' },
  { code: 'DE', name: 'Allemagne', flag: 'de' },
  { code: 'ES', name: 'Espagne', flag: 'es' },
  { code: 'PT', name: 'Portugal', flag: 'pt' },
  { code: 'IT', name: 'Italie', flag: 'it' },
  { code: 'GB', name: 'Royaume-Uni', flag: 'gb' },
  { code: 'NL', name: 'Pays-Bas', flag: 'nl' },
  // Afrique francophone
  { code: 'MA', name: 'Maroc', flag: 'ma' },
  { code: 'DZ', name: 'Algérie', flag: 'dz' },
  { code: 'TN', name: 'Tunisie', flag: 'tn' },
  { code: 'SN', name: 'Sénégal', flag: 'sn' },
  { code: 'CI', name: "Côte d'Ivoire", flag: 'ci' },
  { code: 'CM', name: 'Cameroun', flag: 'cm' },
  { code: 'MG', name: 'Madagascar', flag: 'mg' },
  { code: 'MU', name: 'Maurice', flag: 'mu' },
  // Amérique
  { code: 'CA', name: 'Canada', flag: 'ca' },
  { code: 'HT', name: 'Haïti', flag: 'ht' },
  // Autre
  { code: 'OTHER', name: 'Autre', flag: 'un' },
];

/**
 * Obtenir un pays par code
 */
export const getPaysByCode = (code) => 
  PAYS_LIST.find(p => p.code === code) || PAYS_LIST[0];

// ============================================================================
// STRUCTURE DES CHAMPS DU FORMULAIRE
// Définit tous les champs obligatoires et optionnels
// ============================================================================
export const CHAMPS_FORMULAIRE = {
  // Section Identité
  identite: {
    titre: 'Identité',
    icon: 'Users',
    couleur: 'blue',
    champs: [
      { id: 'nom', label: 'Nom', type: 'text', required: true, placeholder: '' },
      { id: 'prenom', label: 'Prénom', type: 'text', required: true, placeholder: '' },
    ]
  },
  // Section Contact
  contact: {
    titre: 'Contact',
    icon: 'Mail',
    couleur: 'green',
    champs: [
      { id: 'email', label: 'Email', type: 'email', required: true, placeholder: '' },
      { id: 'telephone', label: 'Téléphone', type: 'phone', required: true, placeholder: '', hasIndicatif: true },
    ]
  },
  // Section Informations professionnelles
  professionnel: {
    titre: 'Informations professionnelles',
    icon: 'Building',
    couleur: 'blue',
    fond: 'bg-blue-50',
    bordure: 'border-blue-200',
    champs: [
      { id: 'entreprise', label: 'Raison sociale', type: 'text', required: true, placeholder: 'Mon Entreprise SARL' },
      { id: 'siret', label: 'SIRET (14 chiffres)', type: 'siret', required: true, placeholder: '12345678901234', maxLength: 14 },
      { id: 'statut_juridique', label: 'Statut Juridique', type: 'select', required: true, options: 'STATUTS_JURIDIQUES' },
      { id: 'code_naf', label: 'Code NAF', type: 'text', required: true, placeholder: 'Ex: 4399C', helper: 'Format: 4 chiffres + 1 lettre' },
      { id: 'activite', label: "Secteur d'activité", type: 'text', required: true, placeholder: 'BTP, Commerce, Services, Industrie...' },
    ]
  },
  // Section Adresse
  adresse: {
    titre: 'Adresse',
    icon: 'MapPin',
    couleur: 'red',
    champs: [
      { id: 'adresse', label: 'Adresse', type: 'text', required: true, placeholder: '123 rue de la République' },
      { id: 'complement_adresse', label: "Complément d'adresse", type: 'text', required: false, placeholder: 'Bâtiment A, Étage 2...' },
      { id: 'code_postal', label: 'Code postal', type: 'postal', required: true, placeholder: '97100', maxLength: 5 },
      { id: 'ville', label: 'Ville', type: 'text', required: true, placeholder: 'Basse-Terre' },
      { id: 'territoire', label: "Territoire d'exercice", type: 'select_api', required: true, apiEndpoint: '/api/territoires' },
      { id: 'pays', label: 'Pays', type: 'select', required: true, options: 'PAYS_LIST', defaultValue: 'FR' },
    ]
  },
  // Section Message (optionnelle pour création par admin)
  message: {
    titre: 'Message personnalisé',
    icon: 'Briefcase',
    couleur: 'amber',
    optionnel: true,
    champs: [
      { id: 'message_personnalise', label: 'Message personnalisé (optionnel)', type: 'textarea', required: false, placeholder: 'Un message personnalisé à transmettre au membre...' },
    ]
  }
};

// ============================================================================
// RÈGLES DE VALIDATION
// ============================================================================
export const REGLES_VALIDATION = {
  email: {
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: 'Email invalide'
  },
  siret: {
    pattern: /^[0-9]{14}$/,
    message: 'SIRET invalide (14 chiffres)'
  },
  code_naf: {
    pattern: /^[0-9]{4}[A-Z]?$/,
    message: 'Format: 4 chiffres + 1 lettre'
  },
  code_postal: {
    pattern: /^[0-9]{5}$/,
    message: 'Code postal invalide (5 chiffres)'
  }
};

// ============================================================================
// FONCTIONS UTILITAIRES
// ============================================================================

/**
 * Obtenir l'indicatif par défaut
 */
export const getDefaultIndicatif = () => INDICATIFS_TELEPHONIQUES[0];

/**
 * Trouver un indicatif par code
 */
export const getIndicatifByCode = (code) => 
  INDICATIFS_TELEPHONIQUES.find(i => i.code === code) || getDefaultIndicatif();

/**
 * Obtenir l'URL du drapeau
 */
export const getFlagUrl = (flagCode) => 
  `https://flagcdn.com/w40/${flagCode}.png`;

/**
 * Valider un numéro de téléphone selon l'indicatif
 */
export const validatePhone = (phone, indicatifCode) => {
  const indicatif = getIndicatifByCode(indicatifCode);
  const cleanPhone = phone.replace(/\D/g, '');
  return {
    isValid: cleanPhone.length === indicatif.digits,
    currentLength: cleanPhone.length,
    expectedLength: indicatif.digits,
    cleanPhone
  };
};

/**
 * Valider un champ selon les règles définies
 */
export const validateField = (fieldId, value) => {
  const rule = REGLES_VALIDATION[fieldId];
  if (!rule) return { isValid: true };
  
  const cleanValue = (value || '').toString().replace(/\s/g, '');
  const isValid = rule.pattern.test(cleanValue);
  
  return {
    isValid,
    message: isValid ? null : rule.message
  };
};

/**
 * Obtenir tous les champs obligatoires
 */
export const getRequiredFields = () => {
  const required = [];
  Object.values(CHAMPS_FORMULAIRE).forEach(section => {
    section.champs.forEach(champ => {
      if (champ.required) {
        required.push(champ.id);
      }
    });
  });
  return required;
};

/**
 * Valider le formulaire complet
 */
export const validateFormulaire = (formData, indicatifCode) => {
  const errors = {};
  
  // Vérifier les champs obligatoires
  getRequiredFields().forEach(fieldId => {
    const value = formData[fieldId];
    if (!value || (typeof value === 'string' && !value.trim())) {
      const section = Object.values(CHAMPS_FORMULAIRE).find(s => 
        s.champs.some(c => c.id === fieldId)
      );
      const champ = section?.champs.find(c => c.id === fieldId);
      errors[fieldId] = `${champ?.label || fieldId} est obligatoire`;
    }
  });
  
  // Valider le format des champs avec règles spécifiques
  Object.keys(REGLES_VALIDATION).forEach(fieldId => {
    if (formData[fieldId] && !errors[fieldId]) {
      const validation = validateField(fieldId, formData[fieldId]);
      if (!validation.isValid) {
        errors[fieldId] = validation.message;
      }
    }
  });
  
  // Valider le téléphone
  if (formData.telephone && !errors.telephone) {
    const phoneValidation = validatePhone(formData.telephone, indicatifCode);
    if (!phoneValidation.isValid) {
      errors.telephone = `${phoneValidation.expectedLength} chiffres requis`;
    }
  }
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Export par défaut de toute la configuration
export default {
  INDICATIFS_TELEPHONIQUES,
  STATUTS_JURIDIQUES,
  PAYS_LIST,
  CHAMPS_FORMULAIRE,
  REGLES_VALIDATION,
  getDefaultIndicatif,
  getIndicatifByCode,
  getFlagUrl,
  validatePhone,
  validateField,
  getRequiredFields,
  validateFormulaire
};
